/**
 * Check if two given dates are at the same date
 */
export default function isSameDate(a, b) {
  return a.toDateString() === b.toDateString();
}
